import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { FontStyrene } from '@alfa-bank/site-font-styrene';

import styles from './styles.css';
import type { IDepsDesktop, TProfitabilityCellDesktop } from './models';
import { ProfitabilityCell as Component } from './component';

// eslint-disable-next-line styler/check-styler
export const ProfitabilityCellDesktop = createWidget<IDepsDesktop, TProfitabilityCellDesktop>({
    Text,
    FontStyrene,
    textView: 'primary-large',
    styles,
})(Component);
